import React, { JSX, useEffect, useState } from 'react'

type OwnedProps = 'value' | 'min' | 'max' | 'onChange' | 'onFocus' | 'onBlur' | 'onKeyDown' | 'type'
type NativeInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, OwnedProps>

export const NumberInput = ({
  value,
  min,
  max,
  onCommit,
  ...rest
}: {
  value: number
  min: number
  max?: number
  onCommit: (n: number) => void
} & NativeInputProps): JSX.Element => {
  const [text, setText] = useState(String(value))
  const [focused, setFocused] = useState(false)

  useEffect(() => {
    if (!focused) setText(String(value))
  }, [value, focused])

  const commit = (): void => {
    const parsed = Number.parseInt(text, 10)
    const floored = Math.max(min, Number.isNaN(parsed) ? 0 : parsed)
    const bounded = max !== undefined ? Math.min(max, floored) : floored
    setText(String(bounded))
    onCommit(bounded)
  }

  return (
    <input
      {...rest}
      type='text'
      inputMode='numeric'
      value={text}
      onChange={(e) => {
        const raw = e.target.value
        if (/^-?\d*$/.test(raw)) setText(raw)
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => {
        setFocused(false)
        commit()
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') commit()
      }}
    />
  )
}
